var Module = /** @class */ (function () {
    /**
     * Creates a Neo Module
     * @param name The module name
     * @param typesRegistrationHandler Types registration handler which adds all types for this module to the container
     */
    function Module(name, typesRegistrationHandler) {
        this.name = name;
        this.typesRegistrationHandler = typesRegistrationHandler;
    }
    return Module;
}());
export { Module };
